var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "player"
  }, [_c('div', {
    class: 'controls animations ' + [!_vm.onGoingAnimation ? 'disabled' : '']
  }, [_c('player-button', {
    attrs: {
      "btnClassName": 'fas ' + [_vm.animationsOn ? 'fa-stop' : 'fa-play'],
      "on-click": _vm.handleToggleAnimations,
      "ariaLabel": 'Animations ' + [_vm.animationsOn ? 'On' : 'Off'],
      "ariaPressed": !_vm.animationsOn,
      "disabled": !_vm.onGoingAnimation
    }
  })], 1), _c('div', {
    staticClass: "controls mute"
  }, [_c('player-button', {
    attrs: {
      "btnClassName": 'fas ' + [_vm.soundMuted ? 'fa-volume-mute' : 'fa-volume-up'],
      "on-click": _vm.handleMuteSound,
      "ariaLabel": 'Mute',
      "ariaPressed": _vm.soundMuted
    }
  })], 1), _c('div', {
    staticClass: "controls volume"
  }, [_c('player-button', {
    attrs: {
      "btnClassName": 'fas fa-volume-down',
      "on-click": _vm.handleVolumeDown,
      "ariaLabel": 'Volume Down'
    }
  }), _c('span', [_vm._v(_vm._s(_vm.soundVolume * 100) + "%")]), _c('player-button', {
    attrs: {
      "btnClassName": 'fas fa-volume-up',
      "on-click": _vm.handleVolumeUp,
      "ariaLabel": 'Volume Up'
    }
  })], 1), _c('div', {
    class: 'controls caption-button ' + [_vm.showCaption ? '' : 'off']
  }, [_c('player-button', {
    attrs: {
      "on-click": _vm.handleToggleCaption,
      "show-icon": false,
      "show-text": true,
      "textClassName": 'caption-btn-text',
      "text": 'CC ' + [_vm.showCaption ? 'ON' : 'OFF'],
      "ariaLabel": 'Closed Captions',
      "ariaPressed": _vm.showCaption
    }
  })], 1), _c('div', {
    staticClass: "controls caption-size"
  }, [_c('player-button', {
    attrs: {
      "on-click": _vm.handleDecreaseCaption,
      "btnClassName": 'fas fa-minus',
      "ariaLabel": 'Decrease captions font size'
    }
  }), _c('span', [_vm._v(_vm._s(_vm.captionSizePercentage) + "%")]), _c('player-button', {
    attrs: {
      "on-click": _vm.handleIncreaseCaption,
      "btnClassName": 'fas fa-plus',
      "ariaLabel": 'Increase captions font size'
    }
  })], 1), _vm.showCaption ? _c('div', {
    staticClass: "captions",
    style: _vm.cssVars
  }, [_c('span', {
    class: 'caption-text ' + [_vm.caption ? 'padded' : '']
  }, [_vm._v(_vm._s(_vm.caption))])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }